<template>
  <component :is="tagName" class="mic-com title-text_container"
             :href="config.link.link_url"
             :style="{backgroundColor: config.bg_color}">
    <div :class="'title-text title-text_'+(config.align===0?'left':'center')" :style="style">
      <div class="title-text_content">
        <h3 class="title-text_title" :style="titleStyle">{{config.title}}</h3>
        <p class="title-text_desc" :style="descStyle" v-if="config.desc">{{config.desc}}</p>
      </div>
      <div class="title-text_link" :class="'title-text_link_'+config.link_style" v-if="config.is_link" @click="goTo">
        <span>{{config.link_text}}</span>
        <van-icon name="arrow"/>
      </div>
    </div>
  </component>
</template>

<script>
  import Common from '../mixins/Common';

  export default {
	name: 'TitleText',
	props: {},
	mixins: [Common],
	components: {},
	data() {
	  return {};
	},
	created() {
	},
	methods: {
	  goTo() {
		window.location.href = this.config.link.link_url;
	  }
	},
	computed: {
	  style() {
		return {
		  borderBottom: this.config.show_divider ? '1px solid #e5e5e5' : '1px solid transparent'
		};
	  },
	  titleStyle() {
		return {
		  fontSize: this.config.title_size + 'px',
		  fontWeight: this.config.title_weight,
		  color: this.config.title_color
		};
	  },
	  descStyle() {
		return {
		  fontSize: this.config.desc_size + 'px',
		  fontWeight: this.config.desc_weight,
		  color: this.config.desc_color
		};
	  },
	  tagName() {
		return !this.$IS_PREVIEW && this.config.is_link ? 'a' : 'div';
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .title-text_container {
    padding: 0 10px;
    display: block;
  }

  .title-text {
    padding: 10px 0;

    .title-text_title {
      margin: 0;
    }

    .title-text_desc {
      margin: 8px 0 0;
    }

    &.title-text_left {
      display: flex;
      justify-content: space-between;
    }

    &.title-text_center {
      text-align: center;
    }

    .title-text_link {
      font-size: 12px;
      color: @text-color-gray;
      padding-top: 3px;

      i {
        transform: translate(0, 1px);
      }
    }

    .title-text_link_0 {
      color: @active-color;

      i {
        display: none;
      }
    }

    .title-text_link_1 {
    }

    .title-text_link_2 {
      span {
        display: none;
      }
    }
  }
</style>
